import { create } from 'zustand'

export interface LabelLoadginState {
    loading: boolean
    label: number | null | string
    changeLoading: (state: boolean) => void
    changeLabel: (label: number | null | string) => void
}

export const useLabelLoadingStore = create<LabelLoadginState>()((set, get) => ({
    changeLoading: (state: boolean) => {
        set({ loading: state })
    },
    changeLabel: (label: number | null | string) => {
        set({ label })
    },
    loading: false,
    label: null
}))
